var map = {
	"./plate1.jpg": 3306,
	"./plate2.jpg": 1606,
	"./plate3.jpg": 3455,
	"./plate4.jpg": 2387,
	"./plate5.jpg": 3539,
	"./plate6.jpg": 7661,
	"./plate7.jpg": 4928,
	"./plate8.jpg": 4042,
	"./plate9.jpg": 1076,
	"./xplate10.jpg": 2948,
	"./yplate11.jpg": 6591,
	"./zplate12.jpg": 5082
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3015;